import { RouterModule } from '@angular/router';
import { CheckinComponent } from './checkin.component';
import { MainLayoutComponent } from 'src/app/shared/layouts/main-layout/main-layout.component';
import { BookingGuard } from 'src/app/shared/guards/booking/booking.guard';
import { CardGuard } from 'src/app/shared/guards/card/card.guard';
import { StaticPageLayoutComponent } from 'src/app/shared/layouts/static-page-layout/static-page-layout.component';
import { ERoutes } from 'src/app/shared/enums/routes.enum';
import { FallbackDomainComponent } from '../../../shared/common/components/fallback-domain/fallback-domain.component';
var ɵ0 = function () { return import("./pages/terms-and-conditions/terms-and-conditions.module.ngfactory").then(function (m) { return m.TermsAndConditionsModuleNgFactory; }); }, ɵ1 = function () { return import("./pages/landing/landing.module.ngfactory").then(function (m) { return m.LandingModuleNgFactory; }); }, ɵ2 = function () { return import("./../../../shared/pages/booking/booking.module.ngfactory").then(function (m) { return m.BookingModuleNgFactory; }); }, ɵ3 = function () { return import("./../../../shared/pages/link-card/link-card.module.ngfactory").then(function (m) { return m.LinkCardModuleNgFactory; }); }, ɵ4 = function () { return import("./pages/guests/guests.module.ngfactory").then(function (m) { return m.GuestsModuleNgFactory; }); }, ɵ5 = function () { return import("./pages/wizard/wizard.module.ngfactory").then(function (m) { return m.WizardModuleNgFactory; }); };
var routes = [
    {
        path: ERoutes.TERMS,
        component: StaticPageLayoutComponent,
        children: [{
                path: '',
                loadChildren: ɵ0
            }]
    },
    {
        path: ERoutes.SEARCH,
        loadChildren: ɵ1
    },
    {
        path: ':hash',
        canActivate: [BookingGuard],
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                component: CheckinComponent,
                children: [{
                        path: ERoutes.BOOKING,
                        loadChildren: ɵ2
                    }, {
                        path: ERoutes.CARD,
                        canActivate: [CardGuard],
                        loadChildren: ɵ3
                    }, {
                        path: '',
                        loadChildren: ɵ4
                    }, {
                        path: ':occupantId',
                        loadChildren: ɵ5
                    }]
            }
        ]
    },
    { path: '', component: FallbackDomainComponent }
];
export var CheckinRoutingModule = RouterModule.forChild(routes);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
